import { ColumnMetadata } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { Emdash } from "~/components/Punctuation";

export const ISIN_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> = {
    slug: AssetColumns.isin,
    sortsOn: AssetColumns.isin,
    label: "ISIN",
    type: "string",
    tooltip:
        "An ISIN is a 12-digit alphanumeric code that uniquely identifies a specific security.",
    width: 100,
    render: (item) => {
        if (item.isAsset) {
            if (!item.isin) {
                return <Emdash />;
            }

            return <span className="font-mono">{item.isin}</span>;
        }

        return <Emdash />;
    },
};
